module.exports = {
	"swagger": "2.0",
	"info": {
		"description": "ConstructEx API",
		"version": "06022019",
		"title": "ConstructEx API",
		"contact": {
			"email": "chandbasha_s@trigent.com"
		},
		"license": {
			"name": "Apache 2.0",
			"url": "https://stage-projectcloud.newforma.com/ctx/api/v1/"
		}
	},
	"host": "virtserver.swaggerhub.com",
	"basePath": "/titan2/6-feb-history/06022019",
	"schemes": [
		"https"
	],
	"paths": {
		"/auth/tokens": {
			"post": {
				"tags": [
					"Auth Token"
				],
				"summary": "Generate Auth token",
				"description": "Depending on the credentials, generates a token, which is valid for an hour\n",
				"operationId": "login",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"in": "body",
						"name": "payload",
						"description": "login details",
						"required": false,
						"schema": {
							"$ref": "#/definitions/loginRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Success response with token information",
						"schema": {
							"$ref": "#/definitions/loginSuccess"
						}
					},
					"401": {
						"description": "401 Unauthorized",
						"schema": {
							"$ref": "#/definitions/loginFailure"
						}
					}
				}
			}
		},
		"/projects": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Gets the list of projects linked to the account",
				"operationId": "get all projects",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "List of projects linked to the account",
						"schema": {
							"type": "object",
							"properties": {
								"projects": {
									"$ref": "#/definitions/projects"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/projects/roles": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Gets the list of all project roles associated with a project",
				"operationId": "get all projects roles",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of roles associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"roles": {
									"$ref": "#/definitions/roles"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/projects/users": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Gets the list of users linked to the project",
				"operationId": "get project users",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "Get list  of roles associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"users": {
									"$ref": "#/definitions/users"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/submittals/types": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets submittal types of the project",
				"operationId": "get project submittal types",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of submittal types associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"types": {
									"$ref": "#/definitions/types"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/submittals/trades": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets submittal trades related to the project",
				"operationId": "get project submittal trades",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of submittal trades associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"trades": {
									"$ref": "#/definitions/trades"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/submittals/categories": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets submittal categories related to the project",
				"operationId": "get project submittal categories",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of submittal categories associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"categories": {
									"type": "object",
									"example": {
										"6": "Building",
										"7": "Category"
									},
									"properties": {}
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/submittals/{id}": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Get submittal data based on submittal id",
				"operationId": "submittal id",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "id",
						"in": "path",
						"description": "submittal Id",
						"required": true,
						"type": "integer",
						"minimum": 1
					},
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "Submittal details",
						"schema": {
							"$ref": "#/definitions/submittalDetails"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			},
			"put": {
				"tags": [
					"Submittals"
				],
				"summary": "Updates submittal record based on the submittal id. API does not support inserts",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "id",
						"in": "path",
						"description": "Submittal Id",
						"required": true,
						"type": "integer",
						"minimum": 1
					},
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"in": "body",
						"name": "payload",
						"required": false,
						"schema": {
							"$ref": "#/definitions/submittalDetails"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Successfully updated the submittal record",
						"schema": {
							"type": "object",
							"properties": {
								"status": {
									"type": "string",
									"example": "success"
								},
								"submittalId": {
									"type": "integer",
									"example": 12345
								},
								"extSubmittalId": {
									"type": "integer",
									"example": 12345
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/submittals": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Returns submittal data in the specified duration. Pulls data in pages",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"name": "lastSyncTime",
						"in": "query",
						"description": "last sync time in epoch format",
						"required": true,
						"type": "integer"
					},
					{
						"name": "curSyncTime",
						"in": "query",
						"description": "current sync time in epoch format",
						"required": true,
						"type": "integer"
					},
					{
						"name": "batchCount",
						"in": "query",
						"description": "number of items per batch",
						"required": true,
						"type": "integer"
					},
					{
						"name": "batchNo",
						"in": "query",
						"description": "page number",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "list of submittals",
						"schema": {
							"$ref": "#/definitions/submittalsResponse"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			},
			"post": {
				"tags": [
					"Submittals"
				],
				"summary": "Updates or inserts submittals data",
				"operationId": "push",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"in": "body",
						"name": "payload",
						"required": false,
						"schema": {
							"$ref": "#/definitions/putSubmittalRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Successfully updated/inserted submittal data",
						"schema": {
							"$ref": "#/definitions/putSubmittalResponse"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/rfis/types": {
			"get": {
				"tags": [
					"RFIs"
				],
				"summary": "Gets RFI types of the project",
				"operationId": "get project RFI types",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of RFI types associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"types": {
									"$ref": "#/definitions/types"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/rfis/trades": {
			"get": {
				"tags": [
					"RFIs"
				],
				"summary": "Gets RFI trades related to the project",
				"operationId": "get project RFI trades",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of RFI trades associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"trades": {
									"$ref": "#/definitions/trades"
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/rfis/categories": {
			"get": {
				"tags": [
					"RFIs"
				],
				"summary": "Gets RFI categories related to the project",
				"operationId": "get project RFI categories",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "List of RFI categories associated with the project",
						"schema": {
							"type": "object",
							"properties": {
								"projectId": {
									"type": "integer",
									"example": 27
								},
								"categories": {
									"type": "object",
									"example": {
										"6": "Building",
										"7": "Category"
									},
									"properties": {}
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/rfis/{id}": {
			"get": {
				"tags": [
					"RFIs"
				],
				"summary": "Get RFI details based on RFI id",
				"operationId": "RFI id",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "id",
						"in": "path",
						"description": "RFI Id",
						"required": true,
						"type": "integer",
						"minimum": 1
					},
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "RFI details",
						"schema": {
							"$ref": "#/definitions/RFIDetails"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			},
			"put": {
				"tags": [
					"RFIs"
				],
				"summary": "Updates RFI record based on the RFI id. API does not support inserts",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "id",
						"in": "path",
						"description": "RFI Id",
						"required": true,
						"type": "integer",
						"minimum": 1
					},
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"in": "body",
						"name": "payload",
						"required": false,
						"schema": {
							"$ref": "#/definitions/RFIDetails"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Successfully updated the RFI record",
						"schema": {
							"type": "object",
							"properties": {
								"status": {
									"type": "string",
									"example": "success"
								},
								"submittalId": {
									"type": "integer",
									"example": 12345
								},
								"extSubmittalId": {
									"type": "integer",
									"example": 12345
								}
							}
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/rfis": {
			"get": {
				"tags": [
					"RFIs"
				],
				"summary": "Returns RFI details in the specified duration. Pulls data in pages",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"name": "lastSyncTime",
						"in": "query",
						"description": "last sync time in epoch format",
						"required": true,
						"type": "integer"
					},
					{
						"name": "curSyncTime",
						"in": "query",
						"description": "current sync time in epoch format",
						"required": true,
						"type": "integer"
					},
					{
						"name": "batchCount",
						"in": "query",
						"description": "number of items per batch",
						"required": true,
						"type": "integer"
					},
					{
						"name": "batchNo",
						"in": "query",
						"description": "page number",
						"required": true,
						"type": "integer"
					}
				],
				"responses": {
					"200": {
						"description": "list of RFI",
						"schema": {
							"$ref": "#/definitions/RFIResponse"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			},
			"post": {
				"tags": [
					"RFIs"
				],
				"summary": "Updates or inserts RFI data",
				"operationId": "pushRFI",
				"produces": [
					"application/json"
				],
				"parameters": [
					{
						"name": "Authorization",
						"in": "header",
						"description": "valid access token",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectId",
						"in": "query",
						"description": "valid project id",
						"required": true,
						"type": "integer"
					},
					{
						"in": "body",
						"name": "payload",
						"required": false,
						"schema": {
							"$ref": "#/definitions/putRFIRequest"
						}
					}
				],
				"responses": {
					"200": {
						"description": "Successfully updated/inserted RFI data",
						"schema": {
							"$ref": "#/definitions/putRFIResponse"
						}
					},
					"400": {
						"description": "Invalid token",
						"schema": {
							"$ref": "#/definitions/invalidToken"
						}
					}
				}
			}
		},
		"/webhook_url_provided_by_client": {
			"post": {
				"tags": [
					"Web Hook"
				],
				"summary": "A webhook is basically a user-defined HTTP callback url that is triggered when a submittal/Rfi event occurs at the ConstructEx",
				"produces": [
					"application/json"
				],
				"parameters": [],
				"responses": {
					"200": {
						"description": "updates on submittal/Rfi",
						"schema": {
							"$ref": "#/definitions/WebhookResponse"
						}
					}
				}
			}
		}
	},
	"definitions": {
		"invalidToken": {
			"type": "object",
			"properties": {
				"status": {
					"type": "string",
					"example": "Bad Request"
				},
				"error": {
					"type": "string",
					"example": "token invalid or expired"
				}
			}
		},
		"loginFailure": {
			"type": "object",
			"properties": {
				"status": {
					"type": "string",
					"example": "Unauthorized"
				},
				"error": {
					"type": "string",
					"example": "Invalid clientId/clientSecret"
				}
			}
		},
		"loginSuccess": {
			"type": "object",
			"properties": {
				"status": {
					"type": "string",
					"example": "success"
				},
				"access_token": {
					"type": "string",
					"format": "uuid",
					"example": "d290f1ee6c544b0190e6d701748f0851"
				},
				"created_at": {
					"type": "string",
					"example": "2018-09-08T10:23:46"
				},
				"expires_at": {
					"type": "string",
					"example": "2018-09-08T11:23:45"
				},
				"project": {
					"type": "string",
					"example": "1750 elm street"
				},
				"modules": {
					"type": "array",
					"items": {
						"type": "string",
						"enum": [
							"Submittal",
							"RFI"
						]
					}
				}
			},
			"example": {
				"access_token": "d290f1ee6c544b0190e6d701748f0851",
				"expires_at": "2018-09-08T11:23:45",
				"created_at": "2018-09-08T10:23:46"
			}
		},
		"submittalsResponse": {
			"properties": {
				"currentDateTime": {
					"type": "string",
					"example": "2018-09-08T11:23:45"
				},
				"submittalDetails": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalDetails"
					}
				}
			},
			"example": {
				"currentDateTime": "2018-09-08T11:23:45",
				"submittalDetails": [
					{
						"id": 1234567,
						"number": [
							1234,
							5677
						],
						"revision": 1,
						"title": "43780: Add manually",
						"status": "(Open) Reviewed by Reviewer, Owner Reviewer or Project Admin (Owner)",
						"createdDate": "2013-10-18",
						"requestDueDate": "2015-09-30",
						"expectedDate": "2018-09-30",
						"referenceId": "",
						"trade": [
							{
								"tradeName": "Structural",
								"tradeId": 1
							},
							{
								"tradeName": "Structural",
								"tradeId": 1
							}
						],
						"category": [
							{
								"catId": 1,
								"catName": "Building"
							},
							{
								"catId": 1,
								"catName": "Building"
							}
						],
						"type": [
							{
								"typeName": "Shop Drawings",
								"typeId": 1
							},
							{
								"typeName": "Shop Drawings",
								"typeId": 1
							}
						],
						"attachments": [
							"url of an attachment1",
							"url of an attachment1"
						],
						"submittalUsers": [
							{
								"userId": 122,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "This is test comment"
							},
							{
								"userId": 111,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "this is test comment"
							}
						],
						"reviewStatus": "Reviewed",
						"returnDate": "2018-11-01",
						"closeDate": "2018-11-02",
						"closeComment": "Test Comments"
					},
					{
						"id": 1234567,
						"number": [
							1234,
							5677
						],
						"revision": 1,
						"title": "43780: Add manually",
						"status": "(Open) Reviewed by Reviewer, Owner Reviewer or Project Admin (Owner)",
						"createdDate": "2013-10-18",
						"requestDueDate": "2015-09-30",
						"expectedDate": "2018-10-01",
						"referenceId": "",
						"trade": [
							{
								"tradeName": "Structural",
								"tradeId": 1
							},
							{
								"tradeName": "Structural",
								"tradeId": 1
							}
						],
						"category": [
							{
								"catId": 1,
								"catName": "Building"
							},
							{
								"catId": 1,
								"catName": "Building"
							}
						],
						"type": [
							{
								"typeName": "Shop Drawings",
								"typeId": 1
							},
							{
								"typeName": "Shop Drawings",
								"typeId": 1
							}
						],
						"attachments": [
							"url of an attachment1",
							"url of an attachment1"
						],
						"submittalUsers": [
							{
								"userId": 122,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "This is test comment"
							},
							{
								"userId": 111,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "this is test comment"
							}
						],
						"reviewStatus": "Reviewed",
						"returnDate": "2018-11-01",
						"closeDate": "2018-11-02",
						"closeComment": "Test Comments"
					}
				]
			}
		},
		"submittalDetails": {
			"properties": {
				"id": {
					"type": "integer",
					"format": "int32",
					"example": 1234567
				},
				"referenceId": {
					"type": "integer",
					"format": "int32",
					"example": 1234567
				},
				"number": {
					"type": "string",
					"example": "what to do"
				},
				"specNumber": {
					"type": "string",
					"example": "alphanumeric data here"
				},
				"revision": {
					"type": "integer",
					"format": "int32",
					"example": "by default 0"
				},
				"title": {
					"type": "string",
					"example": "My submittal title"
				},
				"status": {
					"type": "string",
					"example": "(Open) Reviewed by Reviewer, Owner Reviewer or Project Admin (Owner)"
				},
				"createdDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"requestDueDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"expectedDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"reviewStatus": {
					"type": "string",
					"example": "ok"
				},
				"returnDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"closeDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"closeComment": {
					"type": "string",
					"example": "Submittal accepted"
				},
				"type": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalType"
					}
				},
				"trade": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalTrades"
					}
				},
				"category": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalCategory"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"type": "string",
						"enum": [
							"url of an attachment1",
							"url of an attachment2"
						]
					}
				},
				"submittalUsers": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalUsers"
					}
				},
				"submittalHistory": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalHistory"
					}
				}
			},
			"example": {
				"id": 1234567,
				"number": [
					1234,
					5677
				],
				"revision": 1,
				"title": "43780: Add manually",
				"status": "(Open) Reviewed by Reviewer, Owner Reviewer or Project Admin (Owner)",
				"createdDate": "2013-10-18",
				"requestDueDate": "2015-09-30",
				"expectedDate": "2015-10-30",
				"referenceId": "",
				"trade": [
					{
						"tradeName": "Structural",
						"tradeId": 1
					},
					{
						"tradeName": "Structural",
						"tradeId": 1
					}
				],
				"category": [
					{
						"catId": 1,
						"catName": "Building"
					},
					{
						"catId": 1,
						"catName": "Building"
					}
				],
				"type": [
					{
						"typeName": "Shop Drawings",
						"typeId": 1
					},
					{
						"typeName": "Shop Drawings",
						"typeId": 1
					}
				],
				"attachments": [
					"url of an attachment1",
					"url of an attachment1"
				],
				"submittalUsers": [
					{
						"userId": 122,
						"emailId": "ben.chapman.newforma@gmail.com",
						"comment": "This is test comment"
					},
					{
						"userId": 111,
						"emailId": "ben.chapman.newforma@gmail.com",
						"comment": "this is test comment"
					}
				],
				"submittalHistory": [
					{
						"role": "Project Admin (Design),",
						"roleId": "3,",
						"state": "Answered,",
						"date": "1530007993,",
						"userId": 269
					}
				],
				"reviewStatus": "Reviewed",
				"returnDate": "2018-11-01",
				"closeDate": "2018-11-02",
				"closeComment": "Test Comments"
			}
		},
		"submittalType": {
			"type": "object",
			"properties": {
				"typeId": {
					"type": "integer",
					"example": 1
				},
				"typeName": {
					"type": "string",
					"example": "Shop Drawings"
				}
			},
			"example": {
				"typeName": "Shop Drawings",
				"typeId": 1
			}
		},
		"submittalTrades": {
			"type": "object",
			"properties": {
				"tradeId": {
					"type": "integer",
					"example": 1
				},
				"tradeName": {
					"type": "string",
					"example": "Structural"
				}
			},
			"example": {
				"tradeName": "Structural",
				"tradeId": 1
			}
		},
		"submittalCategory": {
			"type": "object",
			"properties": {
				"catId": {
					"type": "integer",
					"example": 1
				},
				"catName": {
					"type": "string",
					"example": "Building"
				}
			},
			"example": {
				"catId": 1,
				"catName": "Building"
			}
		},
		"putRFIRequest": {
			"type": "object",
			"properties": {
				"RFIDetails": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RFIDetails"
					}
				}
			}
		},
		"putSubmittalRequest": {
			"type": "object",
			"properties": {
				"submittalDetails": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalDetails"
					}
				}
			}
		},
		"putSubmittalResponse": {
			"example": {
				"successSubmittals": [
					{
						"referenceId": 123456,
						"id": 654321
					},
					{
						"referenceId": 123457,
						"id": 754321
					},
					{
						"referenceId": 123458,
						"id": 854321
					}
				],
				"errorSubmittals": [
					{
						"id": 123456,
						"referenceId": 654321,
						"message": "invalid submittal title"
					},
					{
						"id": 123457,
						"referenceId": 754321,
						"message": "invalid submittal trades"
					},
					{
						"id": 123458,
						"referenceId": 854321,
						"message": "No submittal found with submittal id 123458"
					}
				]
			}
		},
		"putRFIResponse": {
			"example": {
				"successRFIS": [
					{
						"referenceId": 123456,
						"id": 654321
					},
					{
						"referenceId": 123457,
						"id": 754321
					},
					{
						"referenceId": 123458,
						"id": 854321
					}
				],
				"errorRFIs": [
					{
						"id": 123456,
						"referenceId": 654321,
						"message": "invalid rfi title"
					},
					{
						"id": 123457,
						"referenceId": 754321,
						"message": "invalid rfi trades"
					},
					{
						"id": 123458,
						"referenceId": 854321,
						"message": "No rfi found with rfi id"
					}
				]
			}
		},
		"loginRequest": {
			"type": "object",
			"required": [
				"clientId",
				"clientSecret"
			],
			"properties": {
				"clientId": {
					"type": "string",
					"description": "valid email id"
				},
				"clientSecret": {
					"type": "string",
					"description": "valid password"
				}
			}
		},
		"submittalHistory": {
			"type": "object",
			"properties": {
				"userId": {
					"type": "integer",
					"description": "User id"
				},
				"comment": {
					"type": "string",
					"description": "Comment posted by user"
				}
			}
		},
		"submittalUsers": {
			"type": "object",
			"properties": {
				"userId": {
					"type": "integer",
					"description": "User id"
				},
				"emailId": {
					"type": "string",
					"description": "email Id of user"
				},
				"comment": {
					"type": "string",
					"description": "Comment posted by user"
				}
			}
		},
		"projects": {
			"type": "object",
			"properties": {
				"id": {
					"type": "integer",
					"description": "project id"
				},
				"name": {
					"type": "string",
					"description": "project name"
				},
				"status": {
					"type": "string",
					"description": "Active or inacive"
				}
			},
			"example": [
				{
					"id": 1,
					"name": "AESC Construction",
					"status": "Active"
				},
				{
					"id": 2,
					"name": "Alpengrove Environmental",
					"status": "Active"
				},
				{
					"id": 3,
					"name": "Aquarium Heights",
					"status": "Inactive"
				}
			]
		},
		"roles": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "integer",
					"description": "project id"
				},
				"roles": {
					"type": "object",
					"properties": {}
				}
			},
			"example": {
				"2": "Architect",
				"3": "Project Admin",
				"4": "Reviewer",
				"8": "Contractor"
			}
		},
		"users": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "integer",
					"description": "project id"
				},
				"roles": {
					"type": "object",
					"properties": {}
				}
			},
			"example": [
				{
					"userId": 21,
					"firstName": "Billy",
					"lastName": "Flaherty",
					"email": "bflaherty@newforma.com",
					"roleId": 2,
					"compId": 3,
					"compName": "Newforma (newforma.com)"
				},
				{
					"userId": 72,
					"firstName": "Jordan",
					"lastName": "Sage",
					"email": "jsage@newforma.com",
					"roleId": 2,
					"compId": 5,
					"compName": "AEC-Sync (aec-sync.com)"
				}
			]
		},
		"types": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "integer",
					"description": "project id"
				},
				"types": {
					"type": "object",
					"properties": {}
				}
			},
			"example": {
				"2": "Shop Drawings",
				"3": "Product Data",
				"4": "Samples",
				"8": "Calculations"
			}
		},
		"trades": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "integer",
					"description": "project id"
				},
				"types": {
					"type": "object",
					"properties": {}
				}
			},
			"example": {
				"2": "Structural",
				"3": "HVAC",
				"4": "Masonry",
				"8": "Plumbing"
			}
		},
		"RFIDetails": {
			"type": "object",
			"properties": {
				"id": {
					"type": "integer",
					"format": "int32",
					"example": 1234567
				},
				"referenceId": {
					"type": "integer",
					"format": "int32",
					"example": 1234567
				},
				"number": {
					"type": "string",
					"example": "what to do"
				},
				"subcontractorRFINum": {
					"type": "string",
					"example": "alphanumeric data here"
				},
				"revision": {
					"type": "integer",
					"format": "int32",
					"example": "by default 0"
				},
				"title": {
					"type": "string",
					"example": "My submittal title"
				},
				"status": {
					"type": "string",
					"example": "Closed by Contractor or PAC (Viewable by Subcontractor)"
				},
				"question": {
					"type": "string",
					"example": "general question"
				},
				"suggestion": {
					"type": "string",
					"example": "general suggestions"
				},
				"submittedDate": {
					"type": "string",
					"format": "date-time",
					"example": "2014-06-22T00:00:00.000Z"
				},
				"dueDate": {
					"type": "string",
					"format": "date-time",
					"example": "2018-01-1"
				},
				"type": {
					"example": ""
				},
				"trade": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalTrades"
					}
				},
				"category": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalCategory"
					}
				},
				"attachments": {
					"type": "array",
					"items": {
						"type": "string",
						"enum": [
							"url of an attachment1",
							"url of an attachment2"
						]
					}
				},
				"rfiUsers": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/submittalUsers"
					}
				}
			},
			"example": {
				"id": 1234567,
				"number": "GE-RFI-1440-00",
				"revision": 0,
				"subcontractorRFINum": "chand",
				"title": "Test RFI",
				"status": "Closed by Contractor or PAC (Viewable by Subcontractor)",
				"question": "Test question",
				"suggestion": "Test suggestion",
				"createdDate": "2014-06-22",
				"SubmittedDate": "2014-06-22",
				"dueDate": "2014-06-30",
				"requestDueDate": "2014-06-30",
				"createdBy": 1,
				"assignedTo": 2,
				"referenceId": 1234,
				"trade": [
					{
						"tradeName": "Structural",
						"tradeId": 1
					},
					{
						"tradeName": "Structural",
						"tradeId": 1
					}
				],
				"category": [
					{
						"catId": 1,
						"catName": "Building"
					},
					{
						"catId": 1,
						"catName": "Building"
					}
				],
				"type": {
					"typeName": "Shop Drawings",
					"typeId": 1
				},
				"attachments": [
					"attachment id url of an attachment1",
					"attachment id url of an attachment1"
				],
				"rfiUsers": [
					{
						"userId": 122,
						"emailId": "ben.chapman.newforma@gmail.com",
						"comment": "This is test comment"
					},
					{
						"userId": 12,
						"emailId": "ben.chapman.newforma@gmail.com",
						"comment": "this is test comment"
					}
				],
				"rfiHistory": [
					{
						"role": 3,
						"roleId": "PAC",
						"state": "Answered",
						"date": "1530007993",
						"userId": 269
					},
					{
						"role": 8,
						"roleId": "Contractor",
						"state": "Answered",
						"date": "1530007993",
						"userId": 269
					}
				],
				"returnDate": "2104-06-22",
				"closeDate": "2014-06-22",
				"closeComment": "close comments"
			}
		},
		"RFIResponse": {
			"properties": {
				"currentDateTime": {
					"type": "string",
					"example": "2018-09-08T11:23:45"
				},
				"rfiDetails": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RFIDetails"
					}
				}
			},
			"example": {
				"currentDateTime": "2018-09-08T11:23:45",
				"rfiDetails": [
					{
						"id": 1234567,
						"number": "GE-RFI-1440-00",
						"revision": 0,
						"subcontractorRFINum": "chand",
						"title": "Test RFI",
						"status": "Closed by Contractor or PAC (Viewable by Subcontractor)",
						"question": "Test question",
						"suggestion": "Test suggestion",
						"createdDate": "2014-06-22",
						"SubmittedDate": "2014-06-22",
						"dueDate": "2014-06-30",
						"requestDueDate": "2014-06-30",
						"createdBy": 1,
						"assignedTo": 2,
						"referenceId": 1234,
						"trade": [
							{
								"tradeName": "Structural",
								"tradeId": 1
							},
							{
								"tradeName": "Structural",
								"tradeId": 1
							}
						],
						"category": [
							{
								"catId": 1,
								"catName": "Building"
							},
							{
								"catId": 1,
								"catName": "Building"
							}
						],
						"type": {
							"typeName": "Shop Drawings",
							"typeId": 1
						},
						"attachments": [
							"attachment id url of an attachment1",
							"attachment id url of an attachment1"
						],
						"rfiUsers": [
							{
								"userId": 122,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "This is test comment"
							},
							{
								"userId": 12,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "this is test comment"
							}
						],
						"rfiHistory": [
							{
								"role": 3,
								"roleId": "PAC",
								"state": "Answered",
								"date": "1530007993",
								"userId": 269
							},
							{
								"role": 8,
								"roleId": "Contractor",
								"state": "Answered",
								"date": "1530007993",
								"userId": 269
							}
						],
						"returnDate": "2104-06-22",
						"closeDate": "2014-06-22",
						"closeComment": "close comments"
					},
					{
						"id": 1234567,
						"number": "GE-RFI-1440-00",
						"revision": 0,
						"subcontractorRFINum": "chand",
						"title": "Test RFI",
						"status": "Closed by Contractor or PAC (Viewable by Subcontractor)",
						"question": "Test question",
						"suggestion": "Test suggestion",
						"createdDate": "2014-06-22",
						"SubmittedDate": "2014-06-22",
						"dueDate": "2014-06-30",
						"requestDueDate": "2014-06-30",
						"createdBy": 1,
						"assignedTo": 2,
						"referenceId": 1234,
						"trade": [
							{
								"tradeName": "Structural",
								"tradeId": 1
							},
							{
								"tradeName": "Structural",
								"tradeId": 1
							}
						],
						"category": [
							{
								"catId": 1,
								"catName": "Building"
							},
							{
								"catId": 1,
								"catName": "Building"
							}
						],
						"type": {
							"typeName": "Shop Drawings",
							"typeId": 1
						},
						"attachments": [
							"attachment id url of an attachment1",
							"attachment id url of an attachment1"
						],
						"rfiUsers": [
							{
								"userId": 122,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "This is test comment"
							},
							{
								"userId": 12,
								"emailId": "ben.chapman.newforma@gmail.com",
								"comment": "this is test comment"
							}
						],
						"returnDate": "2104-06-22",
						"closeDate": "2014-06-22",
						"closeComment": "close comments"
					}
				]
			}
		},
		"WebhookResponse": {
			"properties": {
				"projId": {
					"type": "integer",
					"example": 28
				},
				"modId": {
					"type": "integer",
					"example": 2
				},
				"itemId": {
					"type": "integer",
					"example": 123456
				},
				"status": {
					"type": "string"
				}
			},
			"example": {
				"projId": 27,
				"modId": 1,
				"itemId": 12345,
				"status": "Sent"
			}
		},
		"inline_response_200": {
			"properties": {
				"projects": {
					"$ref": "#/definitions/projects"
				}
			}
		},
		"inline_response_200_1": {
			"properties": {
				"projectId": {
					"type": "integer",
					"example": 27
				},
				"roles": {
					"$ref": "#/definitions/roles"
				}
			}
		},
		"inline_response_200_2": {
			"properties": {
				"projectId": {
					"type": "integer",
					"example": 27
				},
				"users": {
					"$ref": "#/definitions/users"
				}
			}
		},
		"inline_response_200_3": {
			"properties": {
				"projectId": {
					"type": "integer",
					"example": 27
				},
				"types": {
					"$ref": "#/definitions/types"
				}
			}
		},
		"inline_response_200_4": {
			"properties": {
				"projectId": {
					"type": "integer",
					"example": 27
				},
				"trades": {
					"$ref": "#/definitions/trades"
				}
			}
		},
		"inline_response_200_5": {
			"properties": {
				"projectId": {
					"type": "integer",
					"example": 27
				},
				"categories": {
					"type": "object",
					"example": {
						"6": "Building",
						"7": "Category"
					},
					"properties": {}
				}
			}
		},
		"inline_response_200_6": {
			"properties": {
				"status": {
					"type": "string",
					"example": "success"
				},
				"submittalId": {
					"type": "integer",
					"example": 12345
				},
				"extSubmittalId": {
					"type": "integer",
					"example": 12345
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/ConstructExRef/swagger.json
 ** module id = 1383
 ** module chunks = 0
 **/